<template>
  <div id="vessel-monitoring-engine">
    <!-- 行などの状態 -->
    <input-display-condition
      @refreshChannelData="refreshChannelData"
      @refreshChannelOriginList="handleRefreshChannelOriginList"
      @onChangeMode="handleChangeMode"
      ref="engineDisplayCondition"
      :deviceType="deviceInfo.deviceType"
    />
    <!-- チャートとかの行 -->
    <engine-data-details
      ref="engineDataDetails"
      :deviceType="deviceInfo.deviceType"
    />
  </div>
</template>

<script>
import InputDisplayCondition from "./components/InputDisplayCondition";
import EngineDataDetails from "./components/EngineDataDetails";
import {createNamespacedHelpers} from "vuex"
const { mapActions, mapState } = createNamespacedHelpers("enterpriseVesselMonitoringEngine");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  components: {
    InputDisplayCondition,
    EngineDataDetails
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  computed: {
    ...mapState({}),
  },
  data() {
    return {
      deviceInfo: null,
    }
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  methods: {
    ...mapActions(["initializeCustomChannelIds"]),
    /**
     *  チャンネル一覧の再表示(実体は engineDataDetails 内の refreshChannelData() ).
     */
    refreshChannelData(){
      this.$refs.engineDataDetails.refreshChannelData();
    },

    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if (['iPhone', 'iPad'].includes(this.deviceInfo.deviceType)) {
          // iPhone, iPad はメニューを表示しない。
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
          this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
        } else {
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
          const verticalNavMenuWidth = this.$store.state.reduceButton
            ? "reduced"
            : "default";
          this.$store.dispatch(
            'updateVerticalNavMenuWidth',
            verticalNavMenuWidth,
          );
        }
      });
    },
    handleRefreshChannelOriginList() {
      this.$nextTick(async () => {
        this.$refs.engineDataDetails.onResize();
      });
    },
    handleChangeMode() {
      this.$nextTick(async () => {
        this.$refs.engineDataDetails.onResize();
      });
    },
  },
  async created() {
    this.deviceInfo = this.getDeviceInfo();
  },
  mounted() {
    this.onResize();

    this.$vs.loading({
      text: "データ取得中",
      textAfter: true,
      color: this.AISEA_COLOR.BLUE,
      container: '#content-area',
    });
  },
}
</script>
<style lang="scss">
#vessel-monitoring-engine {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}
</style>